import React from "react";

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  fontSize: "0.82rem",
  lineHeight: 1.5,
};
const thStyle = {
  background: "#f1f5f9",
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 700,
  color: "#334155",
  borderBottom: "2px solid #e2e8f0",
  position: "sticky",
  top: 0,
  zIndex: 1,
};
const tdStyle = {
  padding: "9px 12px",
  borderBottom: "1px solid #e2e8f0",
  color: "#475569",
  verticalAlign: "top",
};
const chapterTdStyle = {
  ...tdStyle,
  fontWeight: 600,
  color: "#1e293b",
  whiteSpace: "normal",
  width: "18%",
  minWidth: 140,
};

const chapterThStyle = {
  ...thStyle,
  width: "18%",
  minWidth: 140,
};

/**
 * Reusable syllabus table component.
 * @param {{ data: Array<{chapter: string, y2025: string, y2024: string, y2023: string}>, examLabel: string, accentColor: string }} props
 */
export default function SyllabusTable({ data, examLabel = "2025", accentColor = "#6366f1" }) {
  return (
    <div style={{ overflowX: "auto", borderRadius: 12, border: "1px solid #e2e8f0", boxShadow: "0 1px 6px rgba(0,0,0,0.06)" }}>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={{ ...chapterThStyle, color: accentColor }}>Chapter</th>
            <th style={thStyle}>{examLabel} Syllabus</th>
            <th style={thStyle}>2024 — Extra topics</th>
            <th style={thStyle}>2023 — Extra topics</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => (
            <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
              <td style={chapterTdStyle}>{item.chapter}</td>
              <td style={tdStyle}>{item.y2025}</td>
              <td style={tdStyle}>{item.y2024}</td>
              <td style={tdStyle}>{item.y2023}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
